import { Model } from "@/models";

export default class Generic extends Model {
  static type = "documentsGeneric";
}
